export type Theme = 'light' | 'dark' | 'graphite' | 'tokyo' | 'system'
export type DarkVariant = 'dark' | 'graphite' | 'tokyo'

const THEME_KEY = 'theme'
const SYSTEM_DARK_KEY = 'theme.systemDark'

export function getStoredTheme(): Theme {
  // eslint-disable-next-line sonarjs/different-types-comparison -- DOM lib types window as always present; at SSR runtime it's undefined.
  if (globalThis.window === undefined) return 'system'
  try {
    const val = localStorage.getItem(THEME_KEY)
    if (
      val === 'light' || val === 'dark' || val === 'graphite' ||
      val === 'tokyo' || val === 'system'
    ) return val
  } catch { /* ignore */ }
  return 'system'
}

export function setStoredTheme(theme: Theme): void {
  // eslint-disable-next-line sonarjs/different-types-comparison -- DOM lib types window as always present; at SSR runtime it's undefined.
  if (globalThis.window === undefined) return
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch { /* ignore */ }
}

export function getStoredSystemDark(): DarkVariant {
  // eslint-disable-next-line sonarjs/different-types-comparison -- DOM lib types window as always present; at SSR runtime it's undefined.
  if (globalThis.window === undefined) return 'dark'
  try {
    const val = localStorage.getItem(SYSTEM_DARK_KEY)
    if (val === 'dark' || val === 'graphite' || val === 'tokyo') return val
  } catch { /* ignore */ }
  return 'dark'
}

export function setStoredSystemDark(variant: DarkVariant): void {
  // eslint-disable-next-line sonarjs/different-types-comparison -- DOM lib types window as always present; at SSR runtime it's undefined.
  if (globalThis.window === undefined) return
  try {
    localStorage.setItem(SYSTEM_DARK_KEY, variant)
  } catch { /* ignore */ }
}

function resolveTheme(theme: Theme, systemDark: DarkVariant): Exclude<Theme, 'system'> {
  if (theme !== 'system') return theme
  return globalThis.matchMedia('(prefers-color-scheme: dark)').matches ? systemDark : 'light'
}

export function applyTheme(theme: Theme, systemDark: DarkVariant): void {
  // eslint-disable-next-line sonarjs/different-types-comparison -- DOM lib types window as always present; at SSR runtime it's undefined.
  if (globalThis.window === undefined) return
  const root = document.documentElement
  const resolved = resolveTheme(theme, systemDark)
  // Graphite and Tokyo Night are dark variants — keep `.dark` on so Tailwind
  // `dark:` modifiers and the `.dark`-watching markdown/swagger styles fire.
  const isDarkVariant = resolved === 'dark' || resolved === 'graphite' || resolved === 'tokyo'
  root.classList.toggle('dark', isDarkVariant)
  root.classList.toggle('graphite', resolved === 'graphite')
  root.classList.toggle('tokyo', resolved === 'tokyo')
}
